import React from "preact";

function NextArrow() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 18 18">
      <path
        fill="#333"
        d="M4.5 14.9v1.554a.16.16 0 00.26.126l9.055-7.073a.64.64 0 000-1.01L4.76 1.422a.16.16 0 00-.259.126v1.553c0 .099.046.193.123.253L11.855 9l-7.232 5.648a.325.325 0 00-.123.253z"
      ></path>
    </svg>
  );
}

export default NextArrow;
